import * as wasm from "./arrow2_bg.wasm";
import { __wbg_set_wasm } from "./arrow2_bg.js";
__wbg_set_wasm(wasm);
export * from "./arrow2_bg.js";
